import { useState, useCallback } from 'react';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import { updateCloneable } from '../../../../utils/services/complexDocumentsAPI';
import { useDocumentContext, COMPLEX_DOCUMENT_CONTEXT_KEYS } from '../../../../context/complexDocumentContext';
import { useArtboardContext, CONTEXT_KEYS } from '../../../../context/complexArtboardContext';
import { DESIGN_AREA_SETTINGS_TAB } from '../../../SidebarMenu/translationValues';

const NAMESPACES = ['DESIGN_AREA_SETTINGS_TAB'];

export const useCloneableSettings = () => {
  const { t } = useTranslation(NAMESPACES);
  const documentIdSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.ID], []);
  const [documentId, store] = useDocumentContext(documentIdSelector, 'useCloneableSettings');
  
  const designEditableSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.IS_EDITABLE], []);
  const [isEditable] = useDocumentContext(designEditableSelector, 'useCloneableSettings');
  
  const isOpenDesignSelector = useCallback((store) => store[CONTEXT_KEYS.IS_OPEN_DESIGN], []);
  const [isOpenDesign, updateArtboard] = useArtboardContext(isOpenDesignSelector, 'useCloneableSettings');
  
  const [isCloneable, setIsCloneable] = useState(isEditable);

  const handleOpenDesign = useCallback(() => {
    updateArtboard({
      [CONTEXT_KEYS.SHOW_SIGNUP_PROMPT]: true
    });
  }, [updateArtboard]);

  const onCloneableChange = useCallback(
    async check => {
      if (isOpenDesign) {
        handleOpenDesign();
        return;
      }
      setIsCloneable(check);
      const showErrorMessage = () => {
        if (check) {
          return message.error(
            t(
              DESIGN_AREA_SETTINGS_TAB.EDITABLE_ENABLE_FAIL_ERROR_MESSAGE.key,
              DESIGN_AREA_SETTINGS_TAB.EDITABLE_ENABLE_FAIL_ERROR_MESSAGE.value,
            )
          );
        }
        return message.error(
          t(
              DESIGN_AREA_SETTINGS_TAB.EDITABLE_DISABLE_FAIL_ERROR_MESSAGE.key,
              DESIGN_AREA_SETTINGS_TAB.EDITABLE_DISABLE_FAIL_ERROR_MESSAGE.value,
            )
        );
      };
      try {
        const response = await updateCloneable(documentId, check);
        if (response?.statusCode === 5406) {
          store.set({
            [COMPLEX_DOCUMENT_CONTEXT_KEYS.IS_EDITABLE]: check,
          });
        } else {
          setIsCloneable(!check);
          showErrorMessage();
        }
      } catch (e) {
        setIsCloneable(!check);
        showErrorMessage();
      }
    },
    [documentId, isOpenDesign, handleOpenDesign, store, t],
  );

  return {
    isCloneable,
    onCloneableChange,
  };
};


